/**
 * @generated SignedSource<<42c2eca0a949096aefd98699a3cdbb3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PostSignUpFormRoute_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privacyPolicyPageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableEmailConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailConsentLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormResponse",
      "kind": "LinkedField",
      "name": "userSubscriptionFormResponse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "answers",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Answers_answers"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "8f2a29663e86416247e351b3158c4b99";

module.exports = node;
